import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type ActivityLink} from '../activities-modal/types';

const domain = 'MODALS/SINGLE_ACTIVITY';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (payload: {activityId: string; handleSelectActivity: (activity: ActivityLink) => void; addButtonText?: string}) =>
        payload,
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
